export function range({
  from,
  to,
  step = 1
}) {
  const x = [];
  for (let i = from; i <= to; i += step) {
    x.push(i);
  }
  return x;
}